import { ShareCardButton } from "@/components/ShareCardModal";

/** Shareable catalogue-entity card — branded PNG (hub colour panel, title,
 * scientific name, card fact, QR + short link) for any catalogue page. */
export default function EntityShareCard({ hub, slug, testid = "entity-card-btn" }) {
  return (
    <ShareCardButton
      metaUrl={`/catalogue/entities/${hub}/${slug}/card`}
      imageAlt="Shareable catalogue card"
      downloadName={`naturepulse-${slug}-card.png`}
      note="Every catalogue page is a card — post it, print it, or let someone scan the QR straight into the species."
      testid={testid}
      testidPrefix="entity-card"
    />
  );
}
